import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ExtencionService } from 'src/app/services/extencion.service';

@Component({
  selector: 'app-index-extencion',
  templateUrl: './index-extencion.component.html',
  styleUrls: ['./index-extencion.component.scss'],
})
export class IndexExtencionComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public extencionSvc: ExtencionService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = ['nombre', 'fechaAnterior','fechaNueva','comentario','asignador', 'fechaCreacion', 'botones'];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getExtenciones(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getExtenciones(page: number, numReg: number) {
    this.isLoadingResults = true;

    let objPaginado = {
      page,
      numReg,
      searchString: this.searchString,
    };
    this.extencionSvc
      .getExtencionesServicios(objPaginado)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<any>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getExtenciones(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getExtenciones(0, 10);
  }

  /* 
  edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditEmpleadoComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result=='false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    }); 
  }

  delete(obj: any) {
    console.log(obj);
    this.alertify.confirm('Confirma que quiere eliminar el usuario?', () => {
      this.userSvc.EliminarUsuario(obj).subscribe((res) => {
        if (res) {
          this.getUsers(this.pageIndex, this.pageSize);
          this.alertify.success('Usuario eliminado corectamente.');
        } else {
          this.alertify.error('El usuario no se ha podido eliminar.');
        }
      });
    });
  } */
}
